import {
	type HeadersArgs,
	Outlet,
	useLocation,
	useRouteLoaderData,
} from 'react-router'
import { useTranslation } from 'react-i18next'
import MapShowBtn from '~/components/map/map-show-btn'
import { getPlace } from '~/utils/location/location'
import Text from '~/components/text/text'
import Container from '~/components/container/container'
import { useUserQueries } from '~/utils/queries/userUrlQueries'
import { isRootRoute } from '~/utils/location/location.route.helpers'
import SearchBox from '~/components/place-search/SearchBox'

export async function loader() {
	return {}
}

export function headers({ parentHeaders, loaderHeaders }: HeadersArgs) {
	parentHeaders.append('Server-Timing', loaderHeaders.get('Server-Timing')!)
	return parentHeaders
}

export default function Index() {
	const { userLocation } = useRouteLoaderData('root')
	const userQueries = useUserQueries()
	const { t } = useTranslation()
	const location = useLocation()
	const isRoot = isRootRoute(location.pathname)
	const place = getPlace(userLocation, t)
	const placeItem = () => {
		if (userQueries.userPreferences) {
			return {
				title: t('public_user_preferences_title'),
				description: t('public_user_preferences_description'),
			}
		} else if (userLocation.haveBounds) {
			return {
				title: t('public_map_area_title'),
				description: t('public_map_area_description'),
			}
		} else if (userLocation.nearbySelected) {
			return {
				title: t('public_events_near_you'),
				description: t('public_events_near_you_description'),
			}
		} else {
			return {
				title: t('public_events_in', { location: place }),
				description: t('public_events_in_description', { location: place }),
			}
		}
	}

	return (
		<>
			<div className="relative mt-20 flex overflow-hidden py-10 md:mt-16 md:pt-26 md:pb-20">
				<img
					src="/img/place/default.jpg"
					alt=""
					loading="lazy"
					className="absolute inset-0 h-full w-full object-cover"
				/>
				<div className="from-background to-background/70 absolute inset-0 bg-linear-to-t"></div>

				<Container
					marginY={false}
					className="z-1 flex w-full flex-col items-center text-center"
				>
					<Text
						as="h1"
						className="to-secondary/90 from-secondary/90 via-foreground -mx-3 bg-gradient-to-r bg-clip-text py-2 text-3xl font-extrabold tracking-tight text-transparent sm:text-4xl md:text-5xl"
					>
						{!isRoot || userQueries.userPreferences
							? placeItem().title
							: t('public_evently_slogan')}
					</Text>
					<Text
						as="h2"
						className="text-foreground my-4 max-w-4xl text-lg leading-relaxed font-normal tracking-wide drop-shadow-xs md:text-xl"
					>
						{!isRoot || userQueries.userPreferences
							? placeItem().description
							: t('public_evently_slogan_description')}
					</Text>
					<SearchBox />
				</Container>
			</div>

			<Outlet />

			<MapShowBtn toMap />
		</>
	)
}
